<template>
  <md-dialog :md-active.sync="isShowConfirmQuantity" :md-close-on-esc="false" :md-click-outside-to-close="false">
    <md-dialog-title>ロス数の合計を入力してください</md-dialog-title>
    <md-dialog-content>
      <div class="form-group">
        <input type="number" class="form-control" v-model="quantity" name="quantity" @focus="selected" @click="selected"">
      </div>
    </md-dialog-content>
    <md-dialog-actions class="md-layout md-alignment-top-center md-gutter">
      <div class="md-layout-item md-size-45">
        <button class="btn btn-outline-dark btn-lg btn-block" @click="cancel">キャンセル</button>
      </div>
      <div class="md-layout-item md-size-45">
        <button class="btn btn-primary btn-lg btn-block" @click="confirm">確認</button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>


<script>
  export default {
    name: 'ConfirmQuantity',
    props: {
      isShowConfirmQuantity: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        quantity: 0,
      };
    },
    methods: {
      confirm() {
        this.$emit('confirm', this.quantity);
      },
      cancel() {
        this.$emit('cancel');
      },
      selected(e) {
        setTimeout(function() {
          e.target.setSelectionRange(0, e.target.value.length);
        }, 10);
      },
    },
  };
</script>
<style scoped>
  .form-group {
    margin-bottom: 0;
  }

  .form-control[type=number] {
    text-align: right;
  }

  .md-dialog-actions {
    padding: 8px 0;
  }

  .btn {
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/ConfirmQuantity.vue?8a7087d8